import React, { PureComponent } from 'react'
import { Grid, Button } from '@material-ui/core'

import { connect } from 'react-redux'
import { fetchInvitedEmployees, resendInvite } from '../../../actions/employee'
import ContainerWithTitle from '../../HOC/ContainerWithTitle'
import ListContainer from '../../../components/common/ListContainer'
import moment from 'moment'
import { hasAccess } from '../../../utils/api'
import { Appcues } from '../../../utils/constants'
import { sortArrayByName } from '../../../utils/array'

class InvitedEployees extends PureComponent {
  componentDidMount() {
    this.props.dispatch(fetchInvitedEmployees())
  }

  resendInvite = (id) => {
    Appcues.track('Resent Invite to employee')
    this.props.dispatch(resendInvite(id))
  }

  render() {
    const { invitedEmployees = [] } = this.props.employeeReducer
    const invitedEmployeesSort = sortArrayByName(invitedEmployees || [])
    const updatedEmployees = invitedEmployeesSort.map((emp) => {
      return {
        ...emp,
        roleName: emp.role && emp.role.name,
        isRegistered: emp.registered ? 'Yes' : 'No',
        invitedDate: moment(emp.created).format('MM/DD/YYYY HH:mm:ss'),
        action: <Button>Resend Invite</Button>,
      }
    })

    const invitedEmployeeColumns = [
      { id: 'firstName', label: 'First Name' },
      { id: 'lastName', label: 'Last Name' },
      { id: 'roleName', label: 'Role' },
      { id: 'email', label: 'Email' },
      { id: 'isRegistered', label: 'Registered' },
      { id: 'invitedDate', label: 'Invited Date' },
      { id: 'action', label: '' },
    ]

    return (
      <div>
        <Grid container>
          <Grid className="addButton" item xs={12} sm={6} md={6} lg={6}>
            <h3>Invited Employees</h3>
          </Grid>
          {hasAccess() ? (
            <Grid className="addButton" item xs={12} sm={6} md={6} lg={6}>
              <Button
                variant="raised"
                className="primary-button pull-right margin-bottom-small"
                onClick={() => this.props.history.push('/settings/manage/inviteemployee')}
              >
                Invite Employee
              </Button>
            </Grid>
          ) : null}
        </Grid>

        <ListContainer
          columns={invitedEmployeeColumns}
          list={updatedEmployees}
          actionText={'Resend Invite'}
          onClick={this.resendInvite}
          onSearch={() => {}}
          term={''}
          hide={true}
          isSectionEmployees
        />
      </div>
    )
  }
}

export default connect((state) => ({
  employeeReducer: state.employeeReducer,
}))(ContainerWithTitle(InvitedEployees, 'Invited Employees'))



// WEBPACK FOOTER //
// ./src/containers/Settings/Employees/InvitedEmployees.js